import { render, staticRenderFns } from "./SelfFilterModel.vue?vue&type=template&id=22ecacd6&scoped=true&"
import script from "./SelfFilterModel.vue?vue&type=script&lang=js&"
export * from "./SelfFilterModel.vue?vue&type=script&lang=js&"
import style0 from "./SelfFilterModel.vue?vue&type=style&index=0&id=22ecacd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ecacd6",
  null
  
)

export default component.exports